// extracted by mini-css-extract-plugin
module.exports = {"titleWrap":"index__titleWrap___PQzI9","title":"index__title___2oPU6","breadcrumb":"index__breadcrumb___1pnha"};